{
  "brand": "Al-Musafer",
  "nav": {
    "settings": "Settings",
    "launcher": "Systems",
    "employees": "Employees",
    "branches": "Branches",
    "changeBranch": "Change Branch",
    "language": "Language",
    "theme": "Theme",
    "changePassword": "Change Password",
    "toggleSidebarHint": "Show/hide sidebar (Ctrl/Cmd+B)"
  },
  "language": {
    "ar": "Arabic",
    "en": "English"
  },
  "action": {
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "confirm": "Confirm",
    "retry": "Refresh",
    "logout": "Log out",
    "backToLogin": "Back to Login",
    "close": "Close",
    "search": "Search",
    "actions": "Actions"
  },
  "state": {
    "loading": "Loading",
    "accessDenied": "Access Denied",
    "forbidden": "You don't have permission to view this page"
  },
  "status": {
    "label": "Status",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "PENDING": "Pending"
  },
  "drawer": {
    "discardTitle": "Discard changes?",
    "discardDescription": "The information you entered will not be saved.",
    "discardConfirm": "Discard",
    "discardCancel": "Keep Editing"
  },
  "field": {
    "actions": "Actions"
  },
  "directory": {
    "all": "All",
    "allStatuses": "All statuses",
    "noResults": "No results.",
    "noData": "No data available",
    "resetFilters": "Reset Filters",
    "requiredNote": "Required fields are marked with an asterisk",
    "showing": "Showing {{start}}-{{end}} of {{total}}",
    "clearFilter": "Clear filter: {{label}}",
    "previous": "Previous",
    "next": "Next"
  },
  "launcher": {
    "title": "Systems",
    "description": "Choose the system you want to open.",
    "empty": "No systems are available for this account in this branch. Contact your administrator.",
    "administration": "Manage Employees & Branches",
    "administrationDescription": "Manage employee accounts and branches shared across systems."
  },
  "employees": {
    "description": "Manage employee accounts shared across systems.",
    "add": "Add Employee",
    "createTitle": "Create Employee",
    "editTitle": "Edit Employee",
    "username": "Username",
    "nameAr": "Arabic Name",
    "nameEn": "English Name",
    "nfcId": "NFC ID",
    "isAdmin": "System Administrator",
    "platforms": "Systems",
    "lastLogin": "Last Login",
    "neverLoggedIn": "Never logged in",
    "resetPassword": "Reset Password",
    "removeNfc": "Remove NFC card",
    "removeNfcDescription": "The NFC card will be removed from \"{{name}}\"'s account. They will no longer be able to sign in with it.",
    "statusConfirmDescription": "\"{{name}}\"'s account status will change.",
    "created": "Employee created successfully",
    "updated": "Employee updated successfully",
    "deleted": "Employee deleted successfully",
    "statusChanged": "Employee status changed successfully",
    "nfcRemoved": "NFC card removed successfully",
    "resetEmailed": "A password reset link was sent to the verified email address.",
    "resetLinkDescription": "This employee has no verified email. Copy the link below and hand it to them directly; it is shown once.",
    "copyLink": "Copy Link",
    "linkCopied": "Link copied"
  },
  "branches": {
    "description": "Manage branches shared across systems.",
    "add": "Add Branch",
    "createTitle": "Create Branch",
    "editTitle": "Edit Branch",
    "code": "Code",
    "statusConfirmDescription": "\"{{name}}\" branch status will change. Deactivating hides it from branch selection in every system.",
    "created": "Branch created successfully",
    "updated": "Branch updated successfully",
    "statusChanged": "Branch status changed successfully"
  },
  "deleteConfirmation": {
    "title": "Delete Confirmation",
    "description": "\"{{name}}\" will be permanently deleted. Are you sure?"
  },
  "passwordChanged": "Password changed successfully",
  "changePasswordDescription": "Enter your current password, then your new password."
}
